import { render, staticRenderFns } from "./DeliveryHolidayList.vue?vue&type=template&id=1f41cb15&scoped=true"
import script from "./DeliveryHolidayList.vue?vue&type=script&lang=js"
export * from "./DeliveryHolidayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f41cb15",
  null
  
)

export default component.exports